import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { closeSidePanel, SidePanel } from '@customer/store/slices/globalSlice';
import { useCallback, useMemo } from 'react';
import SingleAssetPanel from './single-asset-panel/SingleAssetPanel';
import HelpPanel from './help-panel/HelpPanel';
import NotificationsPanel from './notifications-panel/NotificationsPanel';
import { resetDraftFilters } from '@customer/store/slices/filtersSlice';
import FilterPanel from './filter-panel/FilterPanel';
import VehicleInteractionPanel from './vehicle-interaction-panel/VehicleInteractionPanel';
import GeofenceInteractionPanel from './geofence-interaction-panel/GeofenceInteractionPanel';
import TechLibraryDocPanel from './tech-library-doc-panel/TechLibraryDocPanel';
import PartnerResourcePanel from './partner-resource-panel/PartnerResourcePanel';
import AddInvestigationNotePanel from './add-note-form/investigation/AddInvestigationNotePanel';
import AddAssetNotePanel from './add-note-form/asset/AddAssetNotePanel';
import InvestigationAssetPanel from './investigation-asset-panel/InvestigationAssetPanel';
import UserSettingsPanel from './user-settings-panel/UserSettingsPanel';
import EditLoggedInvestigationPanel from './manage-investigation/edit-logged-investigation-panel/EditLoggedInvestigationPanel';
import CreateCustomInvestigationPanel from './manage-investigation/create-custom-investigation-panel/CreateCustomInvestigationPanel';
import EditCustomInvestigationPanel from './manage-investigation/edit-custom-investigation-panel/EditCustomInvestigationPanel';

const useSidePanel = () => {
  const dispatch = useAppDispatch();

  const { sidePanelOpened, sidePanel, sidePanelFilters } = useAppSelector(state => state.global);

  const onDrawerClosed = useCallback(() => {
    dispatch(closeSidePanel());
    dispatch(resetDraftFilters());
  }, [dispatch]);

  const activePanel = useMemo(() => {
    if (sidePanelOpened) {
      switch (sidePanel) {
        case SidePanel.Asset:
          return <SingleAssetPanel />;
        case SidePanel.AddAssetNote:
          return <AddAssetNotePanel />;
        case SidePanel.Help:
          return <HelpPanel />;
        case SidePanel.Notifications:
          return <NotificationsPanel />;
        case SidePanel.VehicleInteraction:
          return <VehicleInteractionPanel />;
        case SidePanel.GeofenceInteraction:
          return <GeofenceInteractionPanel />;
        case SidePanel.AddInvestigationNote:
          return <AddInvestigationNotePanel />;
        case SidePanel.InvestigationAsset:
          return <InvestigationAssetPanel />;
        case SidePanel.PartnerResource:
          return <PartnerResourcePanel />;
        case SidePanel.TechnicalLibraryDoc:
          return <TechLibraryDocPanel />;
        case SidePanel.UserSettings:
          return <UserSettingsPanel />;
        case SidePanel.CreateCustomInvestigation:
          return <CreateCustomInvestigationPanel />;
        case SidePanel.EditCustomInvestigation:
          return <EditCustomInvestigationPanel />;
        case SidePanel.EditLoggedInvestigation:
          return <EditLoggedInvestigationPanel />;
        case SidePanel.Filters:
          if (sidePanelFilters) {
            return <FilterPanel filterGroup={sidePanelFilters} />;
          }
      }
    }

    return null;
  }, [sidePanelOpened, sidePanel, sidePanelFilters]);

  return {
    isDrawerOpen: sidePanelOpened ?? false,
    onDrawerClosed,
    activePanel,
  };
};

export default useSidePanel;
